/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLoginIcon16Regular = forwardRef('ArrowUiAuthLoginIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11 2.75c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H6a.75.75 0 0 0 0 1.5h5A2.75 2.75 0 0 0 13.75 12V4A2.75 2.75 0 0 0 11 1.25H6a.75.75 0 0 0 0 1.5h5Z" }),
        React.createElement("path", { d: "M5.942 4.497a.75.75 0 0 0 .053 1.06L7.866 7.25H1.5a.75.75 0 0 0 0 1.5h6.366l-1.871 1.694A.75.75 0 0 0 7 11.556l2.7-2.444a1.5 1.5 0 0 0 0-2.224l-2.7-2.444a.75.75 0 0 0-1.06.053Z" })));
});
